/**
 * Selections for bulk actions (B-03). UIDs are only unique per IMAP folder, so a selected message
 * is (mailbox, folder, uid) — never just mailbox:uid — and bulk calls send {uid, folder} items.
 */
export interface BulkItem { uid: number; folder: string }
interface Selectable { mailboxId: string; uid: number; folder?: string | null }

/** A stable string key for a Set; JSON so folder names with ':' or '/' round-trip. */
export function selectionKey(m: Selectable): string {
  return JSON.stringify([m.mailboxId, m.folder || 'INBOX', m.uid]);
}

export function parseSelectionKey(key: string): { mailboxId: string; folder: string; uid: number } {
  const [mailboxId, folder, uid] = JSON.parse(key) as [string, string, number];
  return { mailboxId, folder, uid };
}

/** mailboxId → the {uid, folder} items to send to that mailbox's bulk route. */
export function groupSelection(keys: Iterable<string>): Record<string, BulkItem[]> {
  const groups: Record<string, BulkItem[]> = {};
  for (const key of keys) {
    const { mailboxId, folder, uid } = parseSelectionKey(key);
    (groups[mailboxId] ||= []).push({ uid, folder });
  }
  return groups;
}

/**
 * The folder a per-mailbox list asks for (B-17). Spam and Might-be-spam rows live in INBOX *and*
 * the server's Junk folder (020 junk-merge), and the action already scopes the view.
 */
export function listFolderFor(action?: string): string {
  return action === 'spam' || action === 'review' ? 'ALL' : 'INBOX';
}
